import { TeamData } from '../../network/httpClients/PlatformClient/api.schema';

export const COLUMN_IDS = {
  NAME: 'name',
  CREATED: 'created',
  OWNER: 'owner',
  MEMBERS_COUNT: 'membersCount',
  ACTIONS: 'actions',
} as const;

export const TOOLTIP_SUFFIX = '.tooltip';

export const DELETION_TEAM_ID = '-';

export const INITIAL_TEAMS_ROWS_COUNT = 15;

export const EMPTY_TEAMS: readonly TeamData[] = [];
